/**
 * @description: Request result set
 */
export enum ResultEnum {
  SUCCESS = 10000,
  ERROR = 1,
  TIMEOUT = 401,
  TYPE = 'success',
  TOKEN_EXPIRED = 10003, // token 过期
}

/**
 * @description: request method
 */
export enum RequestEnum {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
}

/**
 * @description:  contentType
 */
export enum ContentTypeEnum {
  // json
  JSON = 'application/json;charset=UTF-8',
  // form-data qs
  FORM_URLENCODED = 'application/x-www-form-urlencoded;charset=UTF-8',
  // form-data  upload
  FORM_DATA = 'multipart/form-data;charset=UTF-8',
}

export const NETWORK_ERROR_MSG = '服务或者网络异常，上传失败'
